import { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';

import { Notification, NotificationData } from '../notifications/notification.interface';
import { UserNotification } from '../notifications/user-notification.interface';
import { TopNavBarButton } from '../top-bar/top-bar-button.interface';
import { createIframeMessage, props } from './message.interface';

export const menuMessages = {
	/**
	 * Shows or hides the menu, reversing the current state.
	 */
	toggleVisibility: createIframeMessage('toggle-menu-visibility'),

	/**
	 * TODO: Can be removed? No idea what the parameters should be / what it should do
	 */
	sideMenu: createIframeMessage('sideMenu'),
};

export const keyboardEventsMessages = {
	/**
	 * Used to send a keydown event
	 */
	keyDown: createIframeMessage('keydown', props<{ key: string }>()),
};

export const clipboardMessages = {
	/**
	 * Copies the data to clipboard
	 */
	copy: createIframeMessage('copyToClipboard', props<{ data: string }>()),
};

export const routerMessages = {
	/**
	 * TODO: Remove? it's used by epo but not sure why it's needed...
	 */
	stateChange: createIframeMessage('stateChange', props<{ url: string }>()),

	/**
	 * Navigates to the given url
	 */
	navigateTo: createIframeMessage('nav', props<{ url: string }>()),

	/**
	 * Used to update the window url
	 */
	updateUrl: createIframeMessage('updateUrl', props<{ url: string }>()),
};

export const epoMessages = {
	/**
	 * TODO: Remove? Seems to be unused
	 * Indicates iframe comm api is connected and ready
	 */
	ready: createIframeMessage('ready'),
};

export const userNotificationMessages = {
	/**
	 * Indicates the user has clicked on a user notification
	 */
	notificationClick: createIframeMessage('notificationClick', props<UserNotification<NotificationData>>()),

	/**
	 * Creates a new notification
	 */
	newNotification: createIframeMessage('notification', props<Notification<NotificationData>>()),
};

export const authMessages = {
	/**
	 * Used to request the user session
	 */
	requestUserSession: createIframeMessage('requestUserSession'),

	/**
	 * Used to sent the usersession
	 * TODO: Fix type of usersession
	 */
	userSession: createIframeMessage('userSession', props<any>()),
};

export const topbarMessages = {
	/**
	 * TODO: Split this in seperate messages and remove the action parameter
	 * @deprecated The message should not be used anymore
	 */
	topNav: createIframeMessage(
		'topNav',
		props<
			| { action: 'spin'; isSpinning: boolean; id: TopNavBarButton['id'] }
			| { action: 'removeButton'; id: TopNavBarButton['id'] }
			| { action: 'clearAllButtons' }
			| { action: 'update'; button: Partial<TopNavBarButton> }
			| { action: 'remove'; id: TopNavBarButton['id'] }
			| { action: 'add'; button: Partial<TopNavBarButton> }
			| { action: 'click'; id: TopNavBarButton['id'] }
		>()
	),
};

export const swalMessages = {
	/**
	 * TODO: Separate this message... it's used to show a swal, and for returning results (with different data structures...)
	 */
	swal: createIframeMessage(
		'swal',
		props<
			| { actionId: unknown; options: SweetAlertOptions }
			| { actionId: unknown; result: SweetAlertResult<any> }
			| { actionId: unknown; rejectionReason: string }
		>()
	),
};

export const modalMessages = {
	/**
	 * Indicates a modal is opened
	 */
	opened: createIframeMessage('modalOpen'),

	/**
	 * Indicates a modal is closed
	 */
	closed: createIframeMessage('modalClose'),
};

export const iframeCommMessages = {
	init: createIframeMessage('iframe-comm-init'),
};
